import { Component, inject, OnInit } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ApiServicesService } from '../services/api-services.service';
import { Router } from '@angular/router';
import { UserDetailsService } from '../services/user-details.service';
import { ServicesService } from '../my-profile/services.service';
import { SnackbarService } from '../services/snackbar.service';

@Component({
  selector: 'app-quick-search',
  standalone: true,
  imports: [MatFormFieldModule, MatSelectModule, ReactiveFormsModule, CommonModule],
  templateUrl: './quick-search.component.html',
  styleUrl: './quick-search.component.css'
})
export class QuickSearchComponent implements OnInit {
  // Declare form and variables
  form!: FormGroup;
  ageOptions: number[] = [];
  toageOptions: number[] = [];
  toage: number = 18;
  countryOptions: any[] = [];
  genderOptions: any[] = [];

  // Declare form fields
  see_gender: string = '';
  from_age: string = '';
  to_age: string = '';
  country: string = '';
  loader: boolean = true;
  formval: any;
   private taskservices = inject(ServicesService);
  seekingArray: any;
  petsArray: any;
  profile_completenes: any;

  constructor( public apiservices: ApiServicesService,private fb: FormBuilder, private apiServices: ApiServicesService, private router: Router, private userdetails: UserDetailsService,private snackbarService:SnackbarService) { }

  ngOnInit(): void {
    // Initialize the form group with form controls and validators
    this.form = this.fb.group({
      see_gender: ['', Validators.required],
      age_from: ['', Validators.required],
      age_to: ['', Validators.required],
      country: ['', Validators.required]
    });

    // Generate age options for the selection fields
    this.generateNumbers(18, 90);
    this.generateToAge(this.toage, 90);

   

    const dropdownData = localStorage.getItem("quickdropdownData");
    if (!dropdownData) {
      this.apiservices.getQuickDropdowndata().subscribe({
        next: (response: any) => {
          this.genderOptions = response.data.genders;
          this.countryOptions = response.data.countries;
          this.loader = false;
          localStorage.setItem("quickdropdownData", JSON.stringify(response.data));
        },
        error: (err) => {
          console.error('Error fetching states:', err);
        }
      });
    }else{
      // console.log('dropdownData',dropdownData);
      const parsedData = JSON.parse(dropdownData);
  this.genderOptions = parsedData.genders;
  this.countryOptions = parsedData.countries;
  this.loader = false;

    }



    this.userdetails.userdetails$.subscribe((userData) => {
      // console.log(userData)
      if (userData && userData.user) {
        this.profile_completenes=userData.user.profileCompleteness==1? true : false;
      }
    });


    
  }

  // getDropdowndata() {
  //   this.apiServices.getDropdowndata().subscribe({
  //     next: (response) => {
  //       this.genderOptions = response.data.genders;
  //       this.countryOptions = response.data.countries;
  //       this.loader = false;
  //     }
  //   })
  // }

  // Handle changes in the "From Age" selection
  // onFromAgeChange(selectedAge: number): void {
  //   this.to_age = '';
  //   if (this.toage <= selectedAge) {
  //     this.toageOptions = [];
  //   }
  //   this.toage = selectedAge;
  //   this.generateToAge(this.toage, 90);
  // }


  onFromAgeChange(selectedAge: any): void {
    this.toage = this.form.get('age_to')?.value;
    if (this.toage <= selectedAge) {
      this.toageOptions = [];
      this.form.patchValue({
        age_to: '',
      })
    }
    if (selectedAge !== '') {
      this.toage = selectedAge;
    } else {
      this.toage = 18;
    }
    this.generateToAge(this.toage+1, 90);
  }


  // Generate an array of numbers from a starting point to an endpoint (used for age selection)
  generateNumbers(start: number, end: number): void {
    for (let i = start; i <= end; i++) {
      this.ageOptions.push(i);
    }
  }

  // Generate "To Age" options based on the selected "From Age"
  generateToAge(start: number, end: number): void {
    this.toageOptions = [];
    for (let i = start; i <= end; i++) {
      this.toageOptions.push(i);
    }
  }

  // Handle form submission
  onSubmit(): void {
   
    const formData = this.form.value;
    // Construct the JSON object
    const formDataToSend = {
      seeking_for: JSON.stringify(this.seekingArray), // Convert array to JSON string
      pets: JSON.stringify(this.petsArray),
      country: formData.country || '',
      city: formData.city || '',
      seeking: formData.see_gender || '',
      state: formData.state || '',
      isOnline: null,
      gender: formData.gender || '',
      age_from: formData.age_from || '',
      age_to: formData.age_to || ''
    };

    // console.log('formData.online',formDataToSend.isOnline)
    // this.searchdata(formDataToSend,1,10);
    localStorage.setItem('formData', JSON.stringify(formDataToSend));

    const encryptedData = localStorage.getItem('encryptedUserData');
    if (encryptedData) {
      const decryptedData = this.apiServices.decryptData(encryptedData);
      if (decryptedData && decryptedData.user) {
        const queryParams = this.form.value;
        this.router.navigate(['/my-profile', decryptedData.user.username, 'Search']);
      }
    }
  }




  searchdata(form: any, page: any, limit: any) {
    // console.log('searched')
    this.formval = form; // Parse the string into an object
  
    const petsArray = this.formval.pets ? JSON.parse(this.formval.pets) : [];
    const seekingForArray = this.formval.seeking_for ? JSON.parse(this.formval.seeking_for) : [];
  
    const pets = petsArray.length === 0 ? null : petsArray;
    const seekingFor = seekingForArray.length === 0 ? null : seekingForArray;
    // console.log(this.formval.see_gender,'this.formval.see_gender,');

  
    this.apiservices
      .searchMembers(
        page,
        this.formval.gender,
        this.formval.see_gender,
        this.formval.country,
        this.formval.state,
        this.formval.city,
        this.formval.age_from,
        this.formval.age_to,
        null,
        pets,          // Null if empty array
        seekingFor,    // Null if empty array
        limit,
      )
      .subscribe({
        next: (data: any) => {
          const friends = data; // Assign data to friends
          this.taskservices.setSearchdata(friends); // Save data to the task service

     
          const encryptedData = localStorage.getItem('encryptedUserData');
          if (encryptedData) {
            const decryptedData = this.apiServices.decryptData(encryptedData);
            if (decryptedData && decryptedData.user) {
              const queryParams = this.form.value;
              this.router.navigate(['/my-profile', decryptedData.user.username, 'Search'], { queryParams });
            }
          }
      

        },
        error: (error) => {
          console.error('Error fetching search data:', error); // Log the error for debugging
          this.snackbarService.openCustomSnackbar(
            {
              icon: false,
              message: error.error.message,
              className: 'failed',
            }
          );
        },
      });
}



  openAdvanceSearch() {
    if(this.profile_completenes){
      this.taskservices.toggleDrawer(true);
    }
    const encryptedData = localStorage.getItem('encryptedUserData');
    if (encryptedData) {
      const decryptedData = this.apiServices.decryptData(encryptedData);
      if (decryptedData && decryptedData.user) {
        this.router.navigate(['/my-profile', decryptedData.user.username, 'Search'], {
          queryParams: { }
        });
      }
    }
  }
}
